
    <h1  mat-dialog-title style="text-align: center;
    font-weight: 500;
    font-size: 30px;
    color: #8bc34a;">Today's Scheduled Jobs</h1>
    <div style="    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;">


        <div *ngFor="let job of this.jobs" id="card" style="border: 1px solid #707070;padding: 30px;min-width: 300px;border-radius: 20px;"
        [ngStyle]="{'background-color': job.firststop ? 'yellow' : '',
                     'color': job.firststop ? 'black' : ''}">


          <p  style="text-align: center; font-weight:200;">{{job.customer_name}}-{{job.customer_jobtype}}</p>
          <div> <p style="text-align: center;">{{job.street_address || '(No Address)'}}</p></div>
          <div> <p style="text-align: center;">{{job.subdivision_name}} - {{job.lot}}</p> </div>
          <div [ngStyle]="job.job_status !== 'Scheduled' ? {'background': 'white', 'color': 'black'} : {}" style="display: flex; align-items: center; justify-content: center;">
            <p style="text-align: center; margin: 0;">{{ job.job_status }}</p><span style="font-size: 12px;margin-left: 5px; " *ngIf="job.firststop == true">**First Stop**</span>
          </div>
        </div>

    </div>

   <div style="display: flex;
    justify-content: center;">
      <button mat-button (click)="dref.close(2)"  style="background: #ffffffaf;
    border: 0;
    height: 40px;
    margin: 30px;
    width: 150px;
    color: #111142;">Close</button>
    </div>
  